'use strict';

(function () {
  'use strict';

  angular.module('msGoals').controller('EditHabitsListCtrl', EditHabitsListCtrl);

  EditHabitsListCtrl.$inject = ['habits', 'close', 'goalSvc', 'focus'];

  function EditHabitsListCtrl(habits, close, goalSvc, focus) {
    var vm = this;
    vm.deleteConfirm = deleteConfirm;
    vm.closeModal = closeModal;

    activate();

    ////////////////

    function activate() {
      vm.title = 'EditHabitsListCtrl';
      vm.habits = habits;
      focus.byId('modal-title', 100);
    }

    function deleteConfirm(habit) {
      habit.widgets[0].properties.completed = true;
      goalSvc.updateHabit(habit).then(function () {
        habits.splice(_.findIndex(habits, function (h) {
          return h.id === habit.id;
        }), 1);
        if (habits.length < 1) {
          closeModal();
        }
      });
    }

    function closeModal() {
      // 200ms pause to let ngAnimate hide the modal.
      close(false, 200);
    }
  }
})();